<template>
  <div class="tag">
    <small>{{ title }}</small>
    <button class="btn p-0 text-white" @click="$emit('click', title)">
      <i class="icon-x"></i>
    </button>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: () => ""
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.tag {
  background-color: $primary;
  color: #fff;
  padding: 4px 16px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  height: 32px;
  i {
    // font-weight: bold;
    margin-left: 3px;
  }

  small {
    font-weight: bold;
  }
}
</style>
